export interface AdSlot {
  id: string;
  slotName: string;
  title: string;
  description: string;
  imageUrl: string;
  ctaText: string;
  ctaUrl: string;
  size: string;
}

export const heroLeftAds: AdSlot[] = [
  {
    id: 'ad_slot_hero_left_1',
    slotName: 'ad_slot_hero_left',
    title: 'Promociona tu radio aquí',
    description: 'Alcanza miles de oyentes. Publicita tu estación en la página principal.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20advertising%20banner%20mockup%20with%20radio%20microphone%20and%20sound%20waves%20on%20minimalist%20clean%20background%2C%20corporate%20marketing%20style%2C%20soft%20beige%20and%20warm%20gray%20tones%2C%20spacious%20composition%20with%20copy%20space%2C%20elegant%20business%20promotion%20aesthetic%2C%20premium%20advertising%20mockup&width=600&height=1200&seq=ad-hero-left-1&orientation=portrait',
    ctaText: 'Ver Más',
    ctaUrl: '#planes',
    size: '300x600',
  },
  {
    id: 'ad_slot_hero_left_2',
    slotName: 'ad_slot_hero_left',
    title: 'Anuncia tu negocio local',
    description: 'Conecta con oyentes de tu ciudad. Segmentación por ubicación.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20business%20advertising%20card%20design%20with%20storefront%20icon%20and%20location%20pin%2C%20minimalist%20marketing%20visual%2C%20soft%20cream%20and%20warm%20earth%20tones%2C%20elegant%20corporate%20style%2C%20professional%20promotion%20layout%20with%20generous%20whitespace&width=600&height=1200&seq=ad-hero-left-2&orientation=portrait',
    ctaText: 'Ver Más',
    ctaUrl: '#planes',
    size: '300x600',
  },
  {
    id: 'ad_slot_hero_left_3',
    slotName: 'ad_slot_hero_left',
    title: 'Campaña destacada semanal',
    description: 'Tu marca frente a +89,000 oyentes activos cada día.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20weekly%20campaign%20advertising%20banner%20with%20megaphone%20and%20audience%20visual%2C%20sophisticated%20marketing%20design%2C%20soft%20neutral%20beige%20and%20warm%20gray%20palette%2C%20clean%20spacious%20composition%2C%20premium%20brand%20promotion%20aesthetic%20with%20subtle%20decorative%20elements&width=600&height=1200&seq=ad-hero-left-3&orientation=portrait',
    ctaText: 'Ver Más',
    ctaUrl: '#planes',
    size: '300x600',
  },
  {
    id: 'ad_slot_hero_left_4',
    slotName: 'ad_slot_hero_left',
    title: 'Patrocina una frecuencia premium',
    description: 'Asocia tu marca a frecuencias exclusivas como 94.70 o 103.50 RFW.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20frequency%20sponsorship%20mockup%20with%20golden%20radio%20dial%20numbers%20and%20elegant%20branding%20space%2C%20minimalist%20luxury%20advertising%20design%2C%20soft%20cream%20and%20warm%20metallic%20tones%2C%20sophisticated%20corporate%20promotion%20aesthetic%2C%20clean%20layout%20with%20subtle%20gold%20accents&width=600&height=1200&seq=ad-hero-left-4&orientation=portrait',
    ctaText: 'Ver Más',
    ctaUrl: '#planes',
    size: '300x600',
  },
];

export const heroRightAds: AdSlot[] = [
  {
    id: 'ad_slot_hero_right_1',
    slotName: 'ad_slot_hero_right',
    title: '¿Tienes un evento?',
    description: 'Publicítalo a oyentes en tu ciudad. Segmentación por categoría y ubicación.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Event%20promotion%20advertising%20card%20with%20calendar%20and%20party%20icon%2C%20clean%20modern%20design%2C%20soft%20neutral%20beige%20tones%2C%20minimalist%20marketing%20visual%20with%20generous%20copy%20space%2C%20professional%20event%20sponsorship%20aesthetic&width=600&height=1200&seq=ad-hero-right-1&orientation=portrait',
    ctaText: 'Publicitar Evento',
    ctaUrl: '#planes',
    size: '300x600',
  },
  {
    id: 'ad_slot_hero_right_2',
    slotName: 'ad_slot_hero_right',
    title: 'Sponsor de categoría',
    description: 'Sé el patrocinador oficial de tu categoría de radio favorita.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Category%20sponsorship%20advertising%20banner%20with%20music%20genre%20icons%20and%20brand%20placement%20area%2C%20clean%20modern%20marketing%20design%2C%20soft%20warm%20cream%20and%20beige%20tones%2C%20professional%20promotion%20layout%2C%20sophisticated%20corporate%20style%20with%20subtle%20gradient&width=600&height=1200&seq=ad-hero-right-2&orientation=portrait',
    ctaText: 'Ver Más',
    ctaUrl: '#planes',
    size: '300x600',
  },
  {
    id: 'ad_slot_hero_right_3',
    slotName: 'ad_slot_hero_right',
    title: 'Anuncio por frecuencia',
    description: 'Tu publicidad aparece cada vez que alguien sintoniza una frecuencia específica.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Frequency%20targeted%20advertising%20visual%20with%20digital%20dial%20display%20and%20brand%20space%2C%20clean%20minimalist%20marketing%20design%2C%20soft%20beige%20and%20warm%20gray%20palette%2C%20elegant%20corporate%20promotion%20aesthetic%2C%20spacious%20professional%20layout&width=600&height=1200&seq=ad-hero-right-3&orientation=portrait',
    ctaText: 'Ver Más',
    ctaUrl: '#planes',
    size: '300x600',
  },
  {
    id: 'ad_slot_hero_right_4',
    slotName: 'ad_slot_hero_right',
    title: 'Campaña global',
    description: 'Tu marca en todas las páginas de RadioFrecuenciaWeb. Máximo alcance.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Global%20advertising%20campaign%20visual%20with%20world%20map%20and%20brand%20placement%2C%20elegant%20corporate%20marketing%20design%2C%20soft%20cream%20and%20neutral%20tones%2C%20minimalist%20professional%20aesthetic%2C%20clean%20spacious%20composition%20with%20subtle%20decorative%20elements&width=600&height=1200&seq=ad-hero-right-4&orientation=portrait',
    ctaText: 'Ver Más',
    ctaUrl: '#planes',
    size: '300x600',
  },
];

export interface InlineBanner {
  id: string;
  slotName: string;
  title: string;
  description: string;
  imageUrl: string;
  ctaText: string;
  ctaUrl: string;
  size: string;
}

export const inlineBanners: InlineBanner[] = [
  {
    id: 'ad_slot_home_top',
    slotName: 'ad_slot_home_top',
    title: 'Espacio publicitario — Google AdSense / Sponsor Ready',
    description: 'Banner premium. Máxima visibilidad debajo del hero principal.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Wide%20horizontal%20advertising%20banner%20mockup%20with%20clean%20modern%20design%2C%20soft%20warm%20beige%20background%20with%20subtle%20gradient%2C%20minimalist%20professional%20marketing%20layout%2C%20elegant%20corporate%20style%2C%20generous%20copy%20space%2C%20premium%20advertising%20placement%20visual&width=1940&height=500&seq=ad-banner-top-1&orientation=landscape',
    ctaText: 'Reservar espacio',
    ctaUrl: '#planes',
    size: '970x250',
  },
  {
    id: 'ad_slot_between_sections',
    slotName: 'ad_slot_between_sections',
    title: 'Espacio publicitario — Google AdSense / Sponsor Ready',
    description: 'Banner estratégico entre contenido. Alta retención visual.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20horizontal%20advertising%20banner%20with%20modern%20geometric%20patterns%2C%20soft%20neutral%20beige%20background%2C%20professional%20sponsor%20placement%20layout%2C%20minimalist%20corporate%20design%2C%20elegant%20subtle%20decorations%2C%20sophisticated%20marketing%20visual%20with%20ample%20whitespace&width=1940&height=500&seq=ad-banner-mid-1&orientation=landscape',
    ctaText: 'Reservar espacio',
    ctaUrl: '#planes',
    size: '970x250',
  },
];

export const footerSponsor: InlineBanner = {
  id: 'ad_slot_footer',
  slotName: 'ad_slot_footer',
  title: 'Espacio publicitario — Footer Sponsor Ready',
  description: 'Tu marca en el cierre de cada página. Visibilidad constante.',
  imageUrl: 'https://readdy.ai/api/search-image?query=Wide%20footer%20sponsor%20banner%20mockup%2C%20clean%20corporate%20design%2C%20soft%20cream%20and%20beige%20tones%2C%20professional%20advertising%20placement%20with%20subtle%20brand%20area%2C%20minimalist%20marketing%20layout%2C%20elegant%20and%20spacious%20composition&width=1940&height=500&seq=ad-footer-sponsor&orientation=landscape',
  ctaText: 'Ser sponsor',
  ctaUrl: '#planes',
  size: '728x90',
};